import { createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncThunkConfig } from "~/types/redux";
import firebase from "~/plugins/firebase";

// 認証状態を取得
export const initializeAdmin = createAsyncThunk<string | null, void>(
  "admin/auth/init",
  async () => {
    return new Promise((resolve) => {
      firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
          const idTokenResult = await user.getIdTokenResult(true);
          if (idTokenResult.claims.admin) {
            const uid = user.uid;
            resolve(uid);
          }
        }
        resolve(null);
      });
    });
  }
);

// ログイン
export const loginAdmin = createAsyncThunk<
  string | null,
  {
    email: string;
    password: string;
  },
  AsyncThunkConfig<{
    message: string;
    status: 0 | 1 | 2;
  }>
>("admin/auth/login", async (arg, thunkAPI) => {
  // バリデーション
  if (!arg.email) {
    return thunkAPI.rejectWithValue({
      message: "emailを入力してください",
      status: 1,
    });
  }
  if (!arg.password) {
    return thunkAPI.rejectWithValue({
      message: "パスワードを入力してください",
      status: 2,
    });
  }

  // エラーメッセージ
  let message: string;
  let status: 0 | 1 | 2;

  try {
    const userCredential = await firebase
      .auth()
      .signInWithEmailAndPassword(arg.email, arg.password);
    const user = userCredential.user;
    if (user) {
      try {
        const idTokenResult = await user.getIdTokenResult(true);
        if (idTokenResult.claims.admin) {
          const uid = user?.uid ?? null;
          return uid;
        } else {
          message = "emailまたはパスワードが間違っています";
        }
      } catch (err) {
        message = "通信エラーが発生しました";
      }
    } else {
      message = "emailまたはパスワードが間違っています";
    }
    return thunkAPI.rejectWithValue({
      message,
      status: 0,
    });
  } catch (err) {
    switch (err.code) {
      case "auth/user-not-found":
        message = "emailまたはパスワードが間違っています";
        status = 0;
        break;
      case "auth/wrong-password":
        message = "emailまたはパスワードが間違っています";
        status = 0;
        break;
      case "auth/invalid-email":
        message = "emailアドレスの値が無効です";
        status = 1;
        break;
      default:
        message = "通信エラーが発生しました";
        status = 0;
    }
    return thunkAPI.rejectWithValue({ message, status });
  }
});

// ログアウト処理
export const logoutAdmin = createAsyncThunk<null, void>(
  "admin/auth/logout",
  async () => {
    const sleep = (microSecond: number) =>
      new Promise((resolve) => setTimeout(resolve, microSecond));
    await sleep(500);
    try {
      await firebase.auth().signOut();
    } catch (err) {
      return Promise.reject(new Error(err));
    }
    return null;
  }
);
